"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.V9_PROVIDER_PROFILE_THEME_KEYS = exports.V9_PROVIDER_PROFILE_FALLBACKS = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
const V9_PROVIDER_PROFILE_FALLBACKS = exports.V9_PROVIDER_PROFILE_FALLBACKS = {
  provider_profile_border_radius: 'border_radius',
  provider_profile_border_style: 'border_style',
  provider_profile_border_width: 'border_width',
  provider_profile_box_shadow: 'initial_box_shadow',
  provider_profile_color_background: 'color_background',
  provider_profile_color_border: 'color_border',
  provider_profile_color_badge_background: 'color_background',
  provider_profile_color_badge_text: 'color_text',
  provider_profile_color_badge_border_emphasis: 'color_link',
  alt_provider_profile_image_border_radius: 'border_radius',
  alt_provider_profile_border_radius: 'border_radius'
};
const V9_PROVIDER_PROFILE_THEME_KEYS = exports.V9_PROVIDER_PROFILE_THEME_KEYS = (0, _keys.default)(V9_PROVIDER_PROFILE_FALLBACKS);